import { render, staticRenderFns } from "./ClientAddressField.vue?vue&type=template&id=1c742cc2"
import script from "./ClientAddressField.vue?vue&type=script&lang=js"
export * from "./ClientAddressField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports